import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot,
} from '@angular/router';
import { Router } from '@angular/router/';
import { AppStateFacade } from '@app-state';
import {
    PageMetadata,
    PageMetadataRegistry,
} from '@app/router';
import { AccessCode } from '@models';
import { restrictedUrlTree } from '@pages/shared/restricted-access';

@Injectable()
export class FeatureFlagGuard implements CanActivate {
    constructor(
        private _pageRegistry: PageMetadataRegistry,
        private _appState: AppStateFacade,
        private _router: Router,
    ) { }

    canActivate(
        _route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) {
        const page = this._pageRegistry.findByRoute(state.url);

        if (page && !this._isFeatureEnabledFor(page)) {
            return restrictedUrlTree(this._router, {
                page,
                code: AccessCode.FeatureNotEnabled,
            });
        }

        return true;
    }

    private _isFeatureEnabledFor(page: PageMetadata) {
        return page &&
            !!page.featureFlag &&
            this._appState.settings.isFeatureEnabled(page.featureFlag) ||
            page.featureFlag == null;
    }
}
